import client from './httpClient'
import { AxiosRequestConfig } from 'axios'
import { AUTH_ENDPOINTS } from '../../constants/apiEndpoints'
import { SnsType, SocialLoginRequest } from '../types'

type Data = {
  username: string | number
  confirmationCode?: string
}

type Headers = {
  'Content-Type': string
  'auth-session': string
  'refresh-token': string
}

export default {
  signIn(data: Data) {
    return client.post(AUTH_ENDPOINTS.SIGN_IN, data)
  },
  confirmSignIn({ data, headers }: { data: Data; headers: Headers }) {
    const config: AxiosRequestConfig = {
      headers,
    }
    return client.post(AUTH_ENDPOINTS.CONFIRM_SIGN_IN, data, config)
  },
  refreshToken: async (
    data: { username: string | number; snsType?: SnsType },
    headers: { 'refresh-token': string },
  ) => {
    try {
      const response = await client.post(AUTH_ENDPOINTS.REFRESH_TOKEN, data, { headers })
      return response.data
    } catch (error) {
      console.error('AuthRepository.refreshToken error', error)
      throw error
    }
  },
  socialLoginApi: async (data: SocialLoginRequest) => {
    return client.post(AUTH_ENDPOINTS.SIGN_IN_SNS, data)
  },
}
